var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AuthPageLayout',{attrs:{"title":"Авторизация по ЭЦП"}},[_c('FormAuthByToken',{attrs:{"sign-in":_vm.onSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }